import {
  Edit,
  SimpleForm,
  SelectInput,
  TextInput,
  ReferenceInput,
  BooleanInput,
} from 'react-admin';

export const InsalesEdit = () => (
  <Edit redirect="show">
    <SimpleForm>
      <TextInput source="name" fullWidth label="Имя" required />
      <TextInput source="url" fullWidth label="Url" required />
      <TextInput source="user" fullWidth label="API пользователь" required />
      <TextInput source="password" fullWidth label="API пароль" required />
      <TextInput source="site_url" fullWidth label="Url сайта" required />
      <BooleanInput source="is_enabled" label="Активно" />

      <ReferenceInput source="model_id" reference="models" label="Модель">
        <SelectInput source="id" label="Модель" optionText="name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);
